import {addItem, removeItem, replaceItem} from '../../../common/util/array';

const BASE_ELEMENT = {
  'partCode': '',
  'name': '',
  'partQuantity': 1,
  'rejectionCode': '',
  'rejectionDescription': 'Desconocido',
  'oo': 0,
  'oh': 0,
  'bo': 0,
  'unitFob': 0,
};

export const addElement = (orderDetail) => {
  if (orderDetail.length && !orderDetail[orderDetail.length - 1].partCode) {
    return orderDetail;
  }

  return addItem(orderDetail, BASE_ELEMENT);
};

export const removeElement = (orderDetail, index) => {
  return removeItem(orderDetail, index);
};

export const updateElement = (orderDetail, index, newElement) => {
  if (typeof index !== 'number' || !orderDetail[index]) {
    return orderDetail;
  }
  
  const updatedElement = {
    ...orderDetail[index],
    ...newElement,
    'totalFob': orderDetail[index].partQuantity * newElement.unitFob,
  };

  return replaceItem(orderDetail, index, updatedElement);
};

export const updateElementQuantity = (orderDetail, {index, value}) => {
  const updatedElement = {
    ...orderDetail[index],
    'partQuantity': value,
    'totalFob': value * orderDetail[index].unitFob,
  };
  
  return replaceItem(orderDetail, index, updatedElement);
};

export const updateElementCode = (orderDetail, {index, value}) => {
  const updatedElement = {...BASE_ELEMENT, 'partCode': value};
  
  return replaceItem(orderDetail, index, updatedElement);
};
